import { makeStyles } from '@mui/styles';
import configBackground from "../../assets/images/configBackground.png";

export const useStyles = makeStyles((theme) => ({
	root: {
		backgroundImage: `url(${configBackground})`,
		backgroundSize: "cover",
		height: "100vh",
		width: "100%",
		padding: "32px"
	},
	cardView: {
		background: theme.palette.background.default,
		borderRadius: "12px",
		height: "100%",
		width: "100%"
	},
	header: {
		display: "flex",
		alignItems: "center",
		padding: "20px",
		position: "relative",
		justifyContent: "center"
	},
	btnView: {
		marginBottom: theme.spacing(4),
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between"
	},
	body: {
		padding: theme.spacing(4, 10),
		overflowY: "auto",
		height: `calc(100% - 100px)`
	},
	footerView: {
		display: "flex",
		justifyContent: "flex-end",
		gridGap: "24px",
		marginTop: theme.spacing(2),
		"& button": {
			width: "120px"
		}
	},
	chip: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "28px",
		width: "80px",
		borderRadius: "12px"
	},
	success: {
		background: theme.palette.background.success,
		color: theme.palette.success.dark
	},
	failed: {
		background: theme.palette.background.error,
		color: theme.palette.error.dark
	},
	rowDetails: {
		border: `1px solid ${theme.palette.grey[300]}`,
		borderRadius: "4px 4px 0 0",
		padding: "8px",
		"& table": {
			width: `calc(100% - 24px)`,
			margin: "12px",
			borderCollapse: "collapse",
			"& td, th": {
				border: `1px solid ${theme.palette.grey[200]}`,
				padding: "8px",
				textAlign: "left"
			}
		}
	}
}));
